import React from 'react';

const InfoBox = ({
  quizInProgress,
  currentQuestionNr,
  nrOfQuestions,
  correctNrOfQuestions,
  finishedQuizText,
  link,
  linkText,
  friendlyLinkName,
}) => {
  return (
    <div className="c-quiz-container__infobox">
      {quizInProgress ? (
        <div className="c-quiz-container__infobox__heading">
          <p style={{ marginBottom: 0 }}>
            Fråga {currentQuestionNr} av {nrOfQuestions}
          </p>
        </div>
      ) : (
        <>
          <div className="c-quiz-container__infobox__heading">
            <p>
              Du fick {correctNrOfQuestions}/{nrOfQuestions} rätt!
            </p>
          </div>
          <p>{finishedQuizText}</p>
          {link && (linkText || friendlyLinkName) && (
            <a className="c-quiz-container__infobox__link" href={link}>
              {linkText || friendlyLinkName}
            </a>
          )}
        </>
      )}
    </div>
  );
};

export default InfoBox;
